module.exports = __webpack_public_path__ + "public/Icons/schedule_bookings.svg?43ebee20";